<template>
  <v-row align="center" justify="center">
    <!-- <v-col> </v-col> -->
    <!-- <v-col @click="before">
      <img
        src="../../assets/pinjaman/Back.png"
        srcset="
          ../../assets/pinjaman/Back@2x.png 2x,
          ../../assets/pinjaman/Back@3x.png 3x
        "
        class="Back"
      />
    </v-col> -->
    <v-card
      :class="`d-flex justify-start overflow-hidden wrapper-box`"
      max-width="328"
      tile
      flat
      v-for="(element, i) in testi"
      :key="i"
    >
      <ContentTestiMobile :data="element" />
    </v-card>
    <!-- <v-col @click="next">
      <img
        src="../../assets/pinjaman/Next.png"
        srcset="
          ../../assets/pinjaman/Next@2x.png 2x,
          ../../assets/pinjaman/Next@3x.png 3x
        "
        class="Next"
      />
    </v-col> -->
  </v-row>
</template>
<script>
import ContentTestiMobile from "./ContentTestiMobile";
export default {
  props: { testi: Array },
  data() {
    return {
      pinjaman: [],
      descFontSize: 0,
    };
  },
  components: {
    ContentTestiMobile,
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  computed: {},
  methods: {
    next() {
      Math.easeInOutQuad = function(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      let content = document.querySelector(".wrapper-box");
      console.log("text");
      var start = content.scrollLeft,
        change = start + 200 - start,
        currentTime = 0,
        increment = 20,
        duration = 1250;
      // content.scrollLeft += 200;
      var animateScroll = function() {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        content.scrollLeft = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };
      console.log(currentTime, duration);
      console.log(start);
      animateScroll();
    },
    before() {
      // let content = document.querySelector(".wrapper-box");
      // console.log("text");
      // content.scrollLeft -= 200;
      Math.easeInOutQuad = function(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      let content = document.querySelector(".wrapper-box");
      // if (start !== 0) {
      var start = content.scrollLeft,
        change = -200,
        currentTime = 0,
        increment = 20,
        duration = 1250;
      var animateScroll = function() {
        currentTime -= increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        content.scrollLeft = val;
        if (content.scrollLeft !== 0) {
          setTimeout(animateScroll, increment);
        }
      };
      console.log(currentTime, duration);
      console.log(start);
      animateScroll();
      // }
    },
    resizeEventHandler() {
      this.shapeWidth = `${window.innerWidth / 1.5}px`;
      this.widthBackgroundTable = window.innerWidth / 4.2 + "px";
      this.descFontSize = window.innerWidth / 98 + "px";
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
html {
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
}
h1 {
  flex-grow: 0;
  margin: 100px 101px 60px 102px;
  font-family: Sora;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Back {
  width: 44px;
  height: 44px;
  flex-grow: 0;
  margin-top: 10%;
  object-fit: contain;
}
.Next {
  width: 44px;
  height: 44px;
  flex-grow: 0;
  margin-top: 40%;
  object-fit: contain;
}
</style>
